import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex: 1 1 auto;
    align-self: stretch;
    width: 100%;
    min-height: 0;
    box-sizing: border-box;
    padding: 24px 16px 28px;
`;

const IconWrap = styled.div`
    font-size: 56px;
    line-height: 1;
    color: rgba(150, 165, 195, 0.22);
    margin-bottom: 20px;

    i {
        filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
    }

    @media (min-width: 768px) {
        font-size: 64px;
        margin-bottom: 22px;
    }
`;

const Title = styled.h3`
    margin: 0 0 10px;
    font-size: 1.05rem;
    font-weight: 700;
    color: rgba(245, 248, 255, 0.96);
    letter-spacing: -0.02em;
    line-height: 1.35;
    max-width: 320px;

    @media (min-width: 768px) {
        font-size: 1.12rem;
        max-width: 380px;
    }
`;

const Hint = styled.p`
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.55;
    color: rgba(160, 175, 205, 0.78);
    font-weight: 400;
    max-width: 340px;

    @media (min-width: 768px) {
        font-size: 0.9rem;
        max-width: 400px;
    }
`;

/**
 * Estado vazio em coluna (ícone + título + dica), tema escuro — alinhado a dashboards / relatórios.
 */
function EmptyPeriodState({title, hint, iconClassName, className}) {
    const {t} = useTranslation();
    return (
        <Root className={className} role="status" aria-live="polite">
            <IconWrap aria-hidden>
                <i className={iconClassName}/>
            </IconWrap>
            <Title>{title ?? t('empty_period_title')}</Title>
            <Hint>{hint ?? t('empty_period_hint')}</Hint>
        </Root>
    );
}

EmptyPeriodState.propTypes = {
    title: PropTypes.string,
    hint: PropTypes.string,
    iconClassName: PropTypes.string,
    className: PropTypes.string,
};

EmptyPeriodState.defaultProps = {
    title: undefined,
    hint: undefined,
    iconClassName: 'fas fa-chart-pie',
    className: undefined,
};

export default EmptyPeriodState;
